var map = {
	"./AssignTagTruck.png": 2871,
	"./ZoneMapImageIcon.png": 2872,
	"./assetSummary.png": 2873,
	"./barChart.png": 2874,
	"./battery.png": 2875,
	"./batteryExchange.png": 2876,
	"./batteryLevel.png": 2877,
	"./cages.png": 2878,
	"./deployment.png": 2879,
	"./distribution.png": 2880,
	"./favouriteAssets.png": 2881,
	"./favouritePeople.png": 2882,
	"./favouriteZone.png": 2883,
	"./floorplan.png": 2884,
	"./guage.png": 2885,
	"./hours.png": 2886,
	"./lifecycle.png": 2887,
	"./lineChart.png": 2888,
	"./map.png": 2889,
	"./peopleSummary.png": 2890,
	"./recentItem.png": 2891,
	"./zoneSummary.png": 2892,
	"./zonemap.png": 2893
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 643;